import apiCall from './apiCall';

const getNewRecordCounterSuperAdmin = async () => {
    const URL = '/NewRecordCounter/GetDataCounter';
    return apiCall('get', URL);
};

const getNewRecordCounterAdminFinance = async () => {
    const URL = '/NewRecordCounter/GetDataCounterAdminFinance';
    return apiCall('get', URL);
};

const getNewRecordCounterRequestor = async (id: string) => {
    const URL = `/NewRecordCounter/GetDataCounterRequestor?id=${id}`;
    return apiCall('get', URL);
};

const getNewRecordCounterShipOperator = async (id: string) => {
    const URL = `/NewRecordCounter/GetDataCounterShipOperator?id=${id}`;
    return apiCall('get', URL);
};

const getNewRecordCounterInspectingCompany = async (id: string) => {
    const URL = `/NewRecordCounter/GetDataCounterInspectingCompany?id=${id}`;
    return apiCall('get', URL);
};

export {
    getNewRecordCounterSuperAdmin,
    getNewRecordCounterAdminFinance,
    getNewRecordCounterRequestor,
    getNewRecordCounterShipOperator,
    getNewRecordCounterInspectingCompany
}
